module.exports = __webpack_public_path__ + "static/powerbi-merge-values-after-all-5a6e66b67b7274742b175e3d910bc0a2.png";